import { render, staticRenderFns } from "./RevalidacaoLogin.vue?vue&type=template&id=1c7dcd3e&scoped=true"
import script from "./RevalidacaoLogin.vue?vue&type=script&lang=js"
export * from "./RevalidacaoLogin.vue?vue&type=script&lang=js"
import style0 from "./RevalidacaoLogin.vue?vue&type=style&index=0&id=1c7dcd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7dcd3e",
  null
  
)

export default component.exports